import {  GET_CON_CAPACITY_ALL, GET_CON_CAPACITY_EDIT_HISTORY, SET_CONSUMER_DETAILS,SET_ENERGY_TYPE_DETAILS } from './types';
import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';
import capacityConsumerService from '../../components/Services/capacityConsumer.service';
import consumerDetailsService from '../../components/Services/consumerDetails.service';
import energyTypeService from '../../components/Services/energyType.service';
import { enableButton } from '../ButtonFlag/actions';

export const createCapacityConsumer = ({ reqBody, handleSubmit ,handleCapacityListing}) => async (dispatch) => {
    capacityConsumerService.createConsumerCapacity(reqBody)
        .then((response) => {
            if (response && response.data.code === 200) {
               !handleCapacityListing && getConsumerrCapacityall()(dispatch)
                toast.success(response?.data?.message, toastProperties)
                handleSubmit && handleSubmit('');
                enableButton()(dispatch)
                handleCapacityListing && handleCapacityListing('CapacityListing');
            }
            if (response && response.data.code !== 200) {
                enableButton()(dispatch);
            }
        }).catch((err) => {console.log(err);
            enableButton()(dispatch);})
}

export const updateCapacityConsumer = ( { reqBody, handleSubmit,handleCapacityListing } ) => async (dispatch) => {
    capacityConsumerService.updateConsumerCapacity(reqBody)
        .then((response) => {
            if (response && response.data.code === 200) {
                !handleCapacityListing &&  getConsumerrCapacityall()(dispatch)
                toast.success(response?.data?.message, toastProperties)
                handleSubmit && handleSubmit('');
                enableButton()(dispatch)
                handleCapacityListing && handleCapacityListing('CapacityListing');
            }
            if (response && response.data.code !== 200) {
                enableButton()(dispatch);
            }
        }).catch((err) => {console.log(err);
            enableButton()(dispatch);})
}

export const getConsumerrCapacityall = () => async (dispatch) => {
    capacityConsumerService.getAllConsumerCapacity()
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_CON_CAPACITY_ALL, payload: response?.data?.data });
                // toast.success(response?.data?.message,toastProperties)
            }else if(response.data.code !== 200){
                dispatch({ type: GET_CON_CAPACITY_ALL, payload: response?.data?.data });
            }
        }).catch(err => console.log(err)
        )
}

export const getConsumerDetails = (data) => async (dispatch) => {
    consumerDetailsService.getConsumerDetails(data)
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: SET_CONSUMER_DETAILS, payload: response?.data?.data });
                // toast.success(response?.data?.message,toastProperties)
            }
        }).catch(err => console.log(err)
        )
};

export const getAllEnergyTypes = () => async (dispatch) => {
    energyTypeService.getAllEnegyType()
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: SET_ENERGY_TYPE_DETAILS, payload: response?.data?.data });
                // toast.success(response?.data?.message,toastProperties)
            }
        }).catch(err => console.log(err)
        )
};
export const getCapacityEditHistoryConsumer = (id,setIsLoading) => async (dispatch) => {
    setIsLoading(true)
    capacityConsumerService.getCapacityEditHistoryConsumer(id)
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_CON_CAPACITY_EDIT_HISTORY, payload: response?.data?.data });
                setIsLoading(false)
                // toast.success(response?.data?.message,toastProperties)
            }
        }).catch(err => console.log(err)
        )
};
